import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { useCart } from "../contexts/CartContext";
import { ProductCard } from "../components/ProductCard";
import { toast } from "sonner";

const Shop = () => {
  const { t, lang } = useLang();
  const { addItem } = useCart();
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "all";

  useEffect(() => {
    const q = cat === "all" ? {} : { category: cat };
    api.get("/products", { params: q }).then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, [cat]);

  const cats = [
    { v: "all", label: t("shop.all") },
    { v: "enclosure", label: t("shop.enclosure") },
    { v: "accessories", label: t("shop.accessories") },
    { v: "food", label: t("shop.food") },
    { v: "merch", label: t("shop.merch") },
  ];

  const handleAdd = (product) => {
    addItem({
      item_id: product.id,
      item_type: "product",
      title: product.title,
      cover: product.cover,
      price: product.price,
    });
    toast.success(lang === "es" ? "Añadido al carrito" : "Added to cart");
  };

  return (
    <div data-testid="shop-page" className="bg-[var(--monzal-bg)] min-h-screen">
      <div className="border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-20">
          <div className="overline">{t("nav.shop").toUpperCase()}</div>
          <h1 className="font-display font-light text-4xl lg:text-6xl text-white tracking-tight mt-4">{t("shop.title")}</h1>
          <p className="text-gray-400 mt-4 max-w-xl">{t("shop.sub")}</p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12">
        <div className="flex gap-2 lg:gap-3 mb-10 flex-wrap" data-testid="shop-categories">
          {cats.map((c) => (
            <button
              key={c.v}
              data-testid={`cat-tab-${c.v}`}
              data-testname={`shop-cat-${c.v}`}
              onClick={() => setParams(c.v === "all" ? {} : { cat: c.v })}
              className={`text-xs uppercase tracking-[0.22em] font-display px-4 py-2.5 border transition ${cat === c.v ? "border-[var(--monzal-gold)] text-[var(--monzal-gold)]" : "border-white/10 text-gray-400 hover:border-white/30"}`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {products.map((p, i) => (
            <div key={p.id} className="fade-up" style={{ animationDelay: `${i * 50}ms` }}>
              <ProductCard product={p} onAdd={handleAdd} />
            </div>
          ))}
        </div>
        {products.length === 0 && (
          <div className="text-gray-500 text-center py-24 font-display tracking-wider" data-testid="shop-empty">
            {t("market.noResults")}
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop;
